var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conversation"},[_c('messages'),_c('send-message')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }